import { demoApi } from './demo.ts';
import { httpApi } from './http.ts';
import type { ExpenseApi } from './types.ts';

/** Demo data only in development with VITE_DEMO=1; production builds always use the API. */
export const isDemo = import.meta.env.DEV && import.meta.env.VITE_DEMO === '1';
export const api: ExpenseApi = isDemo ? demoApi : httpApi;
